import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { widgetEditMode, languagesList_, languagesList, IDragFileBrowseData, checkIfFieldDisabled, posibleNetworsCallToAction, IReturnChangesWidgetEditForm, ITranslateWidgetData } from 'na-lib';
import { SettingsService } from 'src/app/service/settings.service';
import { UploadService } from 'src/app/service/upload.service';
import { supportUrlStructure } from 'src/app/supportUrls';
import { urlInvalidCharactersValidator } from 'src/app/validators/formValidators.dt';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-calltoaction-edit-form',
    templateUrl: './calltoaction-edit-form.component.html',
    styleUrl: './calltoaction-edit-form.component.css',
    standalone: false
})

export class CalltoactionEditFormComponent {
  @Input() data:widgetEditMode
  @Output() returnChanges = new EventEmitter<IReturnChangesWidgetEditForm>()
  @Output() formChange = new EventEmitter<FormGroup>();

  callToActionData:any
  oldData:any
  languagesList = languagesList
  translationModeOriginal = false
  dragFileData: IDragFileBrowseData
  callToActionEditform!:FormGroup
  urlData:any
  defaultLanguage:string
  widgetNumber:any
  passId:any
  url:any
  posibleNetworks = posibleNetworsCallToAction
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  dynamicUrl = false
  allNetworks:any=[]
  allNetworksTypes:any=[]
  allNetworksURLS:any=[]
  urlRegex = /^(?:\$\{[A-Za-z0-9._:-]+\}|#\S+|child:[^\s]+|dpp:\/\/main|(?:https?:\/\/|context:\/\/|pass:\/\/|content:\/\/|task:\/\/|tridy:\/\/)\S+)$/;
  urlRegexDoc = /^(?:\$\{[^}]+\}|pass:\/\/[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+)$/;
  urlRegexDynamic = /^\$\{[A-Za-z0-9._:-]+\}$/;

  addUrl: boolean = false;
  changes=false
  private destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private uploadService: UploadService,
    private translate:TranslateService,
    private settingsService: SettingsService
  ){
    const currentLang = this.translate.currentLang() ?? 'en';
    this.languagesList = languagesList_[currentLang]
  }

  ngOnInit():void{
    this.defaultLanguage = this.data.defaultLanguage
    this.callToActionData=this.data.values
    this.oldData=this.callToActionData
    this.url=this.oldData.url
    this.passId = this.data.passId
    this.widgetNumber= this.data.widget

    if(this.data.translateMode){
      let translateData = this.data.translateData
      const {fields, originalLanguageData, defaultLanguageWidgetData, valuesTranslated, selectedLanguage, values} = translateData

      if(translateData.originalLanguageData){
        this.translationModeOriginal = true
        this.dragFileData = translateData.dragFileDataOriginal
        this.initTranslateEditData( defaultLanguageWidgetData, valuesTranslated, originalLanguageData, [],selectedLanguage)
      }else{
        this.translationModeOriginal = false

        this.dragFileData = translateData.dragFileData
        this.initTranslateEditData(values,valuesTranslated, originalLanguageData, fields, selectedLanguage)
      }
    }
    else
    this.initWidgetEdit()
  }

  initTranslateEditData(data, valuesTranslated, originalLanguageData, fields, selectedLanguage){
    let {id, type, filter, imageUrl, imageSize, socialNetworks, name, fallbackUrl, altTitle, iconAlignment} = data
    
    if(imageUrl)
    this.urlData = supportUrlStructure(imageUrl, this.passId, this.settingsService.contextId$)

    if(!originalLanguageData){
      imageUrl = valuesTranslated[selectedLanguage +'.'+id+'.imageUrl']
      altTitle = valuesTranslated[selectedLanguage +'.'+id+'.altTitle']
    }

    this.callToActionEditform =  this.fb.group({
      id: [{value:id ? id : undefined,  disabled: checkIfFieldDisabled('id', fields, originalLanguageData)}],
      imageUrl: [
        { value: imageUrl ? imageUrl : '', disabled: checkIfFieldDisabled('imageUrl', fields, originalLanguageData) },
        [ Validators.pattern(this.urlRegex), urlInvalidCharactersValidator() ]
      ],
      socialNetworks: [{value:socialNetworks ? socialNetworks : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)}],
      type:[{value: type ? type : undefined,  disabled: checkIfFieldDisabled('type', fields, originalLanguageData)}],
      imageSize:[{value: imageSize ? imageSize : undefined,  disabled: checkIfFieldDisabled('imageSize', fields, originalLanguageData)}],
      name: [{value:name ? name : undefined,  disabled: checkIfFieldDisabled('name', fields, originalLanguageData)}],
      filter: [{value:filter ? filter: undefined,  disabled: checkIfFieldDisabled('filter', fields, originalLanguageData)}],
      altTitle:[ {value:altTitle ? altTitle : undefined,  disabled: checkIfFieldDisabled('altTitle', fields, originalLanguageData)}],
      //fallbackUrl:[{value: fallbackUrl ? fallbackUrl : undefined, disabled: checkIfFieldDisabled('fallbackUrl', fields, originalLanguageData) }],
      fallbackUrl: [
        { value: fallbackUrl ? fallbackUrl : '', disabled: checkIfFieldDisabled('fallbackUrl', fields, originalLanguageData) },
        [ Validators.pattern(this.urlRegex), urlInvalidCharactersValidator() ]
      ],
      iconAlignment:[{value:iconAlignment ? iconAlignment : undefined,  disabled: checkIfFieldDisabled('iconAlignment', fields, originalLanguageData)}],
      facebook:[ {value:socialNetworks?.facebook ? socialNetworks?.facebook: undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)} ],
      instagram:[ {value:socialNetworks?.instagram ? socialNetworks?.instagram : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)} ],
      linkedin:[ {value:socialNetworks?.linkedin ? socialNetworks?.linkedin : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)} ],
      youtube:[ {value:socialNetworks?.youtube ? socialNetworks?.socialNetworks : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)} ],
      tiktok:[ {value:socialNetworks?.tiktok ? socialNetworks?.tiktok : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)} ],
      twitter:[ {value:socialNetworks?.twitter ? socialNetworks?.twitter : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)} ],
      threads:[ {value:socialNetworks?.threads ? socialNetworks?.threads : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)} ],
      mastodon:[ {value:socialNetworks?.mastodon ? socialNetworks?.mastodon : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)} ],
      snapchat:[ {value:socialNetworks?.snapchat ? socialNetworks?.snapchat : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)}],
      pinterest:[ {value:socialNetworks?.pinterest ? socialNetworks?.pinterest : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)}],
      vimeo:[ {value:socialNetworks?.vimeo ? socialNetworks?.vimeo : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)}],
      discord:[ {value:socialNetworks?.discord ? socialNetworks?.discord : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)}],
      amazon:[ {value:socialNetworks?.amazon ? socialNetworks?.amazon : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)}],
      reddit:[ {value:socialNetworks?.reddit ? socialNetworks?.reddit : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)}],
      whatsApp:[ {value:socialNetworks?.whatsApp ? socialNetworks?.whatsApp : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)}],
      signal:[ {value:socialNetworks?.signal ? socialNetworks?.signal : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)}],
      telegram:[ {value:socialNetworks?.telegram ? socialNetworks?.telegram : undefined,  disabled: checkIfFieldDisabled('socialNetworks', fields, originalLanguageData)}],
    })
    this.initializeNetworks()

    this.callToActionEditform.get("imageUrl")?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe( (newurl) => {
      if(newurl?.match(/\${(.+)\}/))
        this.dynamicUrl = true
      else
        this.dynamicUrl = false

      this.setFieldValidator('imageUrl', newurl)
    })

  this.callToActionEditform.valueChanges
  .pipe(takeUntil(this.destroy$))
  .subscribe(() => {
    this.emitTranslationChanges();
  });

  this.callToActionEditform.statusChanges
    .pipe(takeUntil(this.destroy$))
    .subscribe(() => {
      this.emitTranslationChanges();
    });

  }

  private emitTranslationChanges() {
    this.returnChanges.emit({
      type: "callToAction",
      form: this.callToActionEditform,
      validForm: this.callToActionEditform.valid,
      translations: {
        imageUrl: this.callToActionEditform.value.imageUrl,
        altTitle: this.callToActionEditform.value.altTitle
      },
      saveDisabled: !this.callToActionEditform.valid
    });

    this.formChange.emit(this.callToActionEditform);
  }

  initWidgetEdit(){
    const {id, type, filter, imageUrl,imageSize, socialNetworks,name, altTitle, fallbackUrl, iconAlignment} = this.callToActionData
    if(imageUrl)
      this.supportUrl(imageUrl)

    this.callToActionEditform = this.fb.group({
      id:[{value:  id ? id : undefined, disabled:false}],
      imageSize:[{value: imageSize ? imageSize : undefined, disabled:false}],
      imageUrl: [ {value: imageUrl ? imageUrl :undefined, disabled:false},[Validators.required, Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      socialNetworks:[{value: socialNetworks ? socialNetworks : undefined, disabled:false}],
      type:[{value: type ? type : undefined, disabled:false}],
      facebook:[ {value: undefined, disabled:false},[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      instagram:[{value: undefined, disabled:false} ,[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      linkedin:[ {value: undefined, disabled:false},[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      youtube:[{value: undefined , disabled:false} ,[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      tiktok:[ {value: undefined , disabled:false},[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      twitter:[ {value: undefined, disabled:false},[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      threads:[ {value: undefined, disabled:false},[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      mastodon:[ {value: undefined, disabled:false},[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      snapchat:[{value: undefined, disabled:false} ,[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      pinterest:[{value: undefined, disabled:false} ,[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      vimeo:[{value: undefined, disabled:false} ,[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      discord:[{value: undefined, disabled:false} ,[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      amazon:[{value: undefined, disabled:false} ,[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      reddit:[{value: undefined, disabled:false} ,[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      whatsApp:[{value: undefined, disabled:false} ,[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      signal:[{value: undefined, disabled:false} ,[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      telegram:[{value: undefined, disabled:false} ,[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      name:[{value: name ? name : undefined, disabled:false}],
      filter:[{value: filter ? filter: undefined, disabled:false}],
      altTitle:[{value: altTitle ? altTitle : undefined, disabled:false}],
      fallbackUrl: [ {value:  fallbackUrl ? fallbackUrl : undefined, disabled:false},[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
      iconAlignment:[{value: iconAlignment ? iconAlignment : undefined, disabled:false}]
    })
    this.checkdyanimcContentUrl(imageUrl)
    this.initializeNetworks()

    this.callToActionEditform.valueChanges.pipe(takeUntil(this.destroy$)).subscribe( async (value:any) => {
      this.allNetworks.forEach( net => {
        if(net.type == "facebook")
          net.url = (value.facebook)

        if(net.type == "instagram")
          net.url = value.instagram

        if(net.type == "linkedin")
          net.url = value.linkedin

        if(net.type == "youtube")
          net.url = value.youtube

        if(net.type == "tiktok")
          net.url = value.tiktok

        if(net.type == "twitter")
          net.url = value.twitter

        if(net.type == "threads")
          net.url = value.threads

        if(net.type == "mastodon")
          net.url = value.mastodon

        if(net.type == "snapchat")
          net.url = value.snapchat

        if(net.type == "pinterest")
          net.url = value.pinterest

        if(net.type == "vimeo")
          net.url = value.vimeo

        if(net.type == "discord")
          net.url = value.discord

        if(net.type == "amazon")
          net.url = value.amazon

        if(net.type == "reddit")
          net.url = value.reddit

        if(net.type == "whatsApp")
          net.url = value.whatsApp

        if(net.type == "signal")
          net.url = value.signal

        if(net.type == "telegram")
          net.url = value.telegram

      })

      try {
        const imageSize = value.imageSize
        if(imageSize?.length == 0 || !imageSize || (imageSize && imageSize[0] == 0 && imageSize[1] == 0) ){
          if(!this.dynamicUrl){
            const urlData  = supportUrlStructure(value.imageUrl, this.passId, this.settingsService.contextId$)
            await this.uploadService.calculateImgFileSize(urlData).then(size => {
              value.imageSize = size
              this.callToActionEditform.patchValue(
                { imageSize: size },
                { emitEvent: false }
              );
            })
          }
        }
      } catch( error) {
        console.log(error)
      }
      
      value.socialNetworks = this.allNetworks

      this.returnChanges.emit({
        type:"callToAction",
        form: this.callToActionEditform,
        validForm: this.callToActionEditform.valid,
        data:value,
        saveDisabled: !this.callToActionEditform.valid
      })

    })

    this.callToActionEditform.get("imageUrl")?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe( (newurl) => {
      if(this.addUrl){
        this.url = newurl
      }
      this.checkdyanimcContentUrl(newurl)
    })

    this.dragFileData = {
      calledFrom: CalltoactionEditFormComponent,
      calledFromData:{
        passId: this.passId,
        widgetNumber:this.widgetNumber,
        widget: "callToAction",
      },
      enableDragDrop: true,
      enableBrowse:true,
      enableMedia:true,
      enableEnterUrl:true,
      enableMultipleDragDrop:false,
      supportedFileTypes:['image/jpeg', 'image/png', 'image/webp'],
      supportedFileAccept:".jpg, .jpeg, .png, .webp",
      maxSizeInBytes: 2 * 1024 * 1024, // 2 MB size limit for compression,
      maxAllowedSizeInBytes:20 * 1024 * 1024, // 20 MB size limit for direct upload,
      returnSupportUrl: undefined,
      returnUrlData: undefined,
      enterUrl:false,
      returnUrlType:undefined
    }
  }

  checkdyanimcContentUrl(value){
    if(value?.match(/\${(.+)\}/))
        this.dynamicUrl = true
      else
        this.dynamicUrl = false
  }

  initializeNetworks(){

    this.posibleNetworks.forEach((pn:any)=> {
      const n = this.callToActionData.socialNetworks.find(net => net.type === pn.name)
      if(n && n.type==pn.name){
        pn.added=true
        pn.url=n.url
        const tn= { type:n.type, url: n.url }
        this.callToActionEditform.patchValue({[pn.name]: pn.url})
        this.allNetworks.push(tn)
        this.callToActionEditform.get(pn.name)?.addValidators(Validators.required)
        this.callToActionEditform.updateValueAndValidity()
      }
    })
  }

  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  addNetwork(x:any){
    const n = {type:x, url:"" }
    let name = ''
    if(!this.allNetworksTypes.includes(n.type)){

      this.posibleNetworks.forEach((pn:any) => {
        if(pn.name==x){
          pn.added=true
          n.url=pn.url
          name = pn.name
        }
      })
      this.allNetworks.push(n)
      this.callToActionEditform.patchValue({ socialNetworks: this.allNetworks })
      this.callToActionEditform.get(name)?.addValidators(Validators.required)
      this.callToActionEditform.updateValueAndValidity()
    }
   
  }

  removeNetwork(r:any){
    const pn = this.posibleNetworks.find((n:any) => n.name === r)
    if(pn){
      pn.added=false
      const index = this.allNetworks.findIndex(el => el.type === r)
      this.allNetworks.splice(index,1)
      this.callToActionEditform.patchValue({ socialNetworks: this.allNetworks })    
    }
    
    this.callToActionEditform.get(r)?.removeValidators(Validators.required)
    this.callToActionEditform.get(r)?.setErrors(null);
    this.callToActionEditform.updateValueAndValidity()
  }

  updateSocialNetwork(sn:any){
    const input=document.getElementById(sn) as HTMLInputElement | null;
    const x= input?.value
   
    this.allNetworks.forEach((value:any, index:any)=>{
      if(value.type==sn)
        value.url=x
    })

    this.callToActionEditform.patchValue({ socialNetworks: this.allNetworks, [sn]: x  })
  }

  typeURL(){
    this.addUrl = true
    this.urlData = './../../assets/img/default.jpg';
  }

  deleteImg(url){
    this.changes=true
    this.url=""
    this.callToActionEditform.patchValue({imageUrl: this.url, imageSize: undefined, altTitle:undefined, fallbackUrl:undefined})
    this.urlData=""
  }

  supportUrl(url){
    this.urlData = url
    if(url){
      try{
        const firebaseUrl = supportUrlStructure(url, this.passId, this.settingsService.contextId$)
        this.urlData=firebaseUrl
      }catch(errro){}
    }
  }

  setFieldValidator(field, value) {
    if (!value) return;

    if (value.match(/\${(.+)\}/)){
      this.callToActionEditform.get(field)?.setValidators([ Validators.pattern(this.urlRegexDynamic)]);
      this.callToActionEditform.get(field)?.updateValueAndValidity({ emitEvent: false });
    } else {
      this.checkPattern_url(field)
    }
  }

  checkPattern_url(field){
    const fiedlValue:any = this.callToActionEditform.get(field)
    if (fiedlValue){
      try {
        const imgUrl = new URL(fiedlValue)

        if(imgUrl.protocol === "pass:" )
          this.callToActionEditform.get(field)?.setValidators([Validators.pattern(this.urlRegexDoc), urlInvalidCharactersValidator()]);

        if(imgUrl.protocol === "tridy:" || imgUrl.protocol === "context:" || imgUrl.protocol === "https:" || imgUrl.protocol === "http:" )
          this.callToActionEditform.get(field)?.setValidators([Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]);
          
        this.callToActionEditform.updateValueAndValidity()
      } catch(e){}
    }
  }

  checkNewUrl(){
    this.url = this.callToActionEditform.value.imageUrl
    this.supportUrl(this.callToActionEditform.value.imageUrl)
  }

  get hasAnyImage(): boolean {
    const urlCtrlValue = this.callToActionEditform?.get("imageUrl")?.value;
    return !!(urlCtrlValue || this.urlData || this.url);
  }

  returnChangesFilters($event){
    this.callToActionEditform.patchValue({filter: $event.newFilters})
  }

  ngOnDestroy(): void {
    this.posibleNetworks.forEach( network => {
      if(this.callToActionEditform.get(network.name))
      network.added = false
    })
    this.destroy$.next();
    this.destroy$.complete();
  }

  returnChangesDragFileBrowseUI($event){
    if($event){
      const {calledFrom, calledFromData, enableDragDrop, enableBrowse, enableMedia,enableEnterUrl, enableMultipleDragDrop, 
        supportedFileTypes,supportedFileAccept, maxSizeInBytes,maxAllowedSizeInBytes, 
        returnSupportUrl,returnUrlData, enterUrl} = $event

        this.dragFileData = $event
      if(enterUrl){
        this.addUrl = true
        this.urlData = './../../assets/img/default.jpg'
      }else{
        this.addUrl = false
        this.urlData = undefined
      }

      if(returnUrlData)
      this.urlData = returnUrlData

      if(returnSupportUrl){
        this.url = returnSupportUrl
        this.callToActionEditform.patchValue({ imageUrl: returnSupportUrl })
      }
    }
  }
}
